import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  // Defensive guard – in the extremely unlikely case Date fails
  const currentYear = (() => {
    try {
      return new Date().getFullYear();
    } catch {
      return new Date().getUTCFullYear();
    }
  })();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-12 sm:py-16 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/857147547f7da499a0fc7d35aaf6d8ec/512cce5c00ccd36955d2d4e00fd25839.png"
              alt="Usine à Leads - Génération de leads qualifiés"
              title="Usine à Leads - Expert en génération de leads"
              className="h-10 sm:h-12 w-auto mb-4"
            />
            <p className="text-white/70 leading-relaxed mb-6 text-sm break-words">
              Transformez votre présence digitale en{' '}
              <strong>usine à générer des rendez-vous qualifiés</strong>. Acquisition,
              conversion et automatisation pour des résultats mesurables.
            </p>
            <nav aria-label="Réseaux sociaux">
              <div className="flex gap-4">
                <a
                  href="https://www.linkedin.com/company/usineleads"
                  rel="noopener noreferrer nofollow"
                  target="_blank"
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition-all duration-300 cursor-pointer flex-shrink-0"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-lg" aria-hidden="true"></i>
                </a>
                <a
                  href="https://www.facebook.com/usineleads"
                  rel="noopener noreferrer nofollow"
                  target="_blank"
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition-all duration-300 cursor-pointer flex-shrink-0"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-lg" aria-hidden="true"></i>
                </a>
                <a
                  href="https://twitter.com/usineleads"
                  rel="noopener noreferrer nofollow"
                  target="_blank"
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition-all duration-300 cursor-pointer flex-shrink-0"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-x-fill text-lg" aria-hidden="true"></i>
                </a>
                <a
                  href="https://www.instagram.com/usineleads"
                  rel="noopener noreferrer nofollow"
                  target="_blank"
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition-all duration-300 cursor-pointer flex-shrink-0"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-fill text-lg" aria-hidden="true"></i>
                </a>
              </div>
            </nav>
          </div>

          {/* Quick Links */}
          <nav aria-label="Navigation rapide">
            <h4 className="font-bold text-base sm:text-lg mb-4">Liens rapides</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="/"
                  className="text-white/70 hover:text-orange-400 transition-colors duration-200 cursor-pointer break-words"
                >
                  Accueil
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="text-white/70 hover:text-orange-400 transition-colors duration-200 cursor-pointer break-words"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="#tarifs"
                  className="text-white/70 hover:text-orange-400 transition-colors duration-200 cursor-pointer break-words"
                >
                  Tarifs
                </a>
              </li>
              <li>
                <a
                  href="#temoignages"
                  className="text-white/70 hover:text-orange-400 transition-colors duration-200 cursor-pointer break-words"
                >
                  Témoignages
                </a>
              </li>
              <li>
                <a
                  href="#contact-form"
                  className="text-white/70 hover:text-orange-400 transition-colors duration-200 cursor-pointer break-words"
                >
                  Contact
                </a>
              </li>
              <li>
                <Link
                  to="/a-propos"
                  className="text-white/70 hover:text-orange-400 transition-colors duration-200 cursor-pointer break-words"
                >
                  À propos — Marc Signorel
                </Link>
              </li>
              <li>
                <Link
                  to="/rdv-iclosed"
                  className="text-white/70 hover:text-orange-400 transition-colors duration-200 cursor-pointer break-words"
                >
                  Réserver un appel
                </Link>
              </li>
            </ul>
          </nav>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-base sm:text-lg mb-4">Contact</h4>
            <address className="not-italic space-y-3 text-sm">
              <div className="flex items-start gap-3 text-white/70">
                <i className="ri-mail-line text-orange-400 mt-0.5 flex-shrink-0" aria-hidden="true"></i>
                <a
                  href="mailto:contact@usineleads.com"
                  className="break-words hover:text-orange-400 transition-colors"
                >
                  contact@usineleads.com
                </a>
              </div>
              <div className="flex items-start gap-3 text-white/70">
                <i className="ri-phone-line text-orange-400 mt-0.5 flex-shrink-0" aria-hidden="true"></i>
                <a href="tel:+33123456789" className="break-words hover:text-orange-400 transition-colors">
                  +33 1 23 45 67 89
                </a>
              </div>
              <div className="flex items-start gap-3 text-white/70">
                <i className="ri-map-pin-line text-orange-400 mt-0.5 flex-shrink-0" aria-hidden="true"></i>
                <span className="break-words">Paris, France</span>
              </div>
            </address>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs sm:text-sm text-white/60">
            <p className="break-words text-center md:text-left">
              © {currentYear} Usine à Leads. Tous droits réservés.
            </p>
            <nav aria-label="Navigation légale">
              <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
                <Link
                  to="/mentions-legales"
                  className="hover:text-orange-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  Mentions légales
                </Link>
                <Link
                  to="/politique-de-confidentialite"
                  className="hover:text-orange-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  Politique de confidentialité
                </Link>
                <Link
                  to="/cgv"
                  className="hover:text-orange-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  CGV
                </Link>
                <a
                  href="https://readdy.ai/?ref=logo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-orange-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  Website Builder
                </a>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}
